import React from "react";
import { Card, CardContent, CardHeader, Chip, Divider, Stack, Typography } from "@mui/material";
import { LocalOffer as LocalOfferIcon, CheckCircle as CheckIcon } from "@mui/icons-material";

import { BILLING_CYCLES } from "../../../subscription";

export default function RegistrationSidebar({
    tierDefinition,
    formattedPrice,
    priceSuffix,
    vatLabel,
    cycle,
    cycleLabel,
    yearlySavingDisplay,
    yearlyEffective,
    featuresToDisplay,
}) {
    return (
        <Card
            sx={{
                height: "100%",
                borderRadius: 3,
                border: (theme) => `1px solid ${theme.palette.divider}`,
            }}
        >
            <CardHeader title={tierDefinition.title} subheader={tierDefinition.subtitle} />
            <CardContent>
                <Stack spacing={2}>
                    <Stack direction="row" alignItems="baseline" gap={1}>
                        <Typography variant="h4" fontWeight={800}>
                            {formattedPrice}
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary">
                            / {priceSuffix}
                        </Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                        {vatLabel} · {cycle === BILLING_CYCLES.MONTHLY ? "monatlich kündbar" : "jährlich abgerechnet"}
                    </Typography>
                    <Chip
                        size="small"
                        label={`Abrechnung: ${cycleLabel}`}
                        variant="outlined"
                        sx={{ alignSelf: "flex-start" }}
                    />
                    {cycle === BILLING_CYCLES.YEARLY && yearlySavingDisplay && (
                        <Chip
                            icon={<LocalOfferIcon />}
                            label={`Spare ${yearlySavingDisplay}`}
                            size="small"
                            color="warning"
                            variant="outlined"
                            sx={{ alignSelf: "flex-start" }}
                        />
                    )}
                    {cycle === BILLING_CYCLES.YEARLY && yearlyEffective && (
                        <Typography variant="caption" color="text.secondary">
                            Effektiv {yearlyEffective} / Monat
                        </Typography>
                    )}

                    <Divider />

                    <Stack spacing={1.25}>
                        {featuresToDisplay.map((feature) => (
                            <Stack key={feature} direction="row" alignItems="center" gap={1}>
                                <CheckIcon fontSize="small" sx={{ color: "orange" }} />
                                <Typography variant="body2">{feature}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
